import React, { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Card, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { firestore } from '../../../../contexts/FirebaseContext';
import useAuth from '../../../../hooks/useAuth';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { formaPagoList, regimenFiscalList, usoCFDI_List } from '../../../../constants/facturarEnvio';

const schema = yup.object().shape({
  name: yup.string().required('Requerido'),
  rfc: yup
    .string()
    .required('Requerido')
    .matches(
      '^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A]|[0-9]){1})?$',
      'Formato incorrecto'
    ),
  phone: yup.string().required('Requerido'),
  email: yup.string().required('Requerido'),
  estado: yup.string().required('Requerido'),
  municipio: yup.string().required('Requerido'),
  ciudad: yup.string().required('Requerido'),
  calle: yup.string().required('Requerido'),
  exterior_number: yup.string().required('Requerido'),
  interior_number: yup.string(),
  colonia: yup.string().required('Requerido'),
  cod_zip: yup.string().required('Requerido'),
  regFiscal: yup.string().required('Requerido'),
  formaPago: yup.string().required('Requerido'),
  uso_CFDI: yup.string().required('Requerido')
});

function FormDatosCliente({ selectCreateId = '', handleClose }) {
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const { user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const { functions } = useSelector((state) => state.selectCreate);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ resolver: yupResolver(schema) });

  const findedFunction = functions.find((fun) => fun.selectCreateId === selectCreateId);

  const submitData = async (dataForm) => {
    setLoading(true);
    dataForm.relatedUser = user.id;
    dataForm.regFiscal_detail = regimenFiscalList.find((item) => item.Codigo === dataForm.regFiscal);
    dataForm.formaPago_detail = formaPagoList.find((item) => item.Codigo === dataForm.formaPago);
    dataForm.uso_CFDI_detail = usoCFDI_List.find((item) => item.Codigo === dataForm.uso_CFDI);
    console.log('datos', dataForm);
    try {
      await firestore.collection('fiscal_direction').add(dataForm);
      setLoading(false);
      enqueueSnackbar('La direccion fiscal se a creado correctamente', { variant: 'success' });
      findedFunction.itemCreateHandler(false);
      // handleClose();
      setSaved(true);
    } catch (error) {
      console.error(error);
      setLoading(false);
      enqueueSnackbar('Error al crear direccion fiscal', { variant: 'error' });
    }
  };

  useEffect(() => {
    setSaved(false);
  }, []);

  return (
    <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(submitData)}>
      <Stack spacing={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
          <Box width="100%">
            <TextField error={!!errors.estado} {...register('estado')} fullWidth label="Estado" variant="outlined" />
            <Typography color="error" fontSize="12px">
              {errors.estado?.message}
            </Typography>
          </Box>
          <Box width="100%">
            <TextField
              error={!!errors.municipio}
              {...register('municipio')}
              fullWidth
              label="Municipio"
              variant="outlined"
            />
            <Typography color="error" fontSize="12px">
              {errors.municipio?.message}
            </Typography>
          </Box>
          <Box width="100%">
            <TextField error={!!errors.ciudad} {...register('ciudad')} fullWidth label="Ciudad" variant="outlined" />
            <Typography color="error" fontSize="12px">
              {errors.ciudad?.message}
            </Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
          <Box width="100%">
            <TextField error={!!errors.colonia} {...register('colonia')} fullWidth label="Colonia" variant="outlined" />
            <Typography color="error" fontSize="12px">
              {errors.colonia?.message}
            </Typography>
          </Box>
          <Box width="100%">
            <TextField
              error={!!errors.cod_zip}
              {...register('cod_zip')}
              fullWidth
              label="Cod. Postal"
              variant="outlined"
            />
            <Typography color="error" fontSize="12px">
              {errors.cod_zip?.message}
            </Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
          <Box width="100%">
            <TextField error={!!errors.calle} {...register('calle')} fullWidth label="Calle" variant="outlined" />
            <Typography color="error" fontSize="12px">
              {errors.calle?.message}
            </Typography>
          </Box>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
            <Box width="100%">
              <TextField
                error={!!errors.exterior_number}
                {...register('exterior_number')}
                fullWidth
                label="N. exterior"
                variant="outlined"
              />
              <Typography color="error" fontSize="12px">
                {errors.exterior_number?.message}
              </Typography>
            </Box>
            <Box width="100%">
              <TextField
                error={!!errors.interior_number}
                {...register('interior_number')}
                fullWidth
                label="N. interior"
                variant="outlined"
              />
              <Typography color="error" fontSize="12px">
                {errors.interior_number?.message}
              </Typography>
            </Box>
          </Stack>
        </Stack>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
          <Box width="100%">
            <TextField error={!!errors.name} {...register('name')} fullWidth label="Nombre" variant="outlined" />
            <Typography color="error" fontSize="12px">
              {errors.name?.message}
            </Typography>
          </Box>
          <Box width="100%">
            <TextField error={!!errors.rfc} {...register('rfc')} fullWidth label="RFC" variant="outlined" />
            <Typography color="error" fontSize="12px">
              {errors.rfc?.message}
            </Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
          <Box width="100%">
            <TextField error={!!errors.phone} {...register('phone')} fullWidth label="Telefono" variant="outlined" />
            <Typography color="error" fontSize="12px">
              {errors.phone?.message}
            </Typography>
          </Box>
          <Box width="100%">
            <TextField error={!!errors.email} {...register('email')} fullWidth label="Email" variant="outlined" />
            <Typography color="error" fontSize="12px">
              {errors.email?.message}
            </Typography>
          </Box>
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
          <TextField
            select
            fullWidth
            label="Regimen fiscal"
            defaultValue=""
            inputProps={register('regFiscal', {
              required: true
            })}
            error={errors.regFiscal}
            helperText={errors.regFiscal?.message}
          >
            {regimenFiscalList.map((option) => (
              <MenuItem key={option.Codigo} value={option.Codigo}>
                {option.Codigo} - {option.Valor}
              </MenuItem>
            ))}
          </TextField>
          {/* <Typography color="error" fontSize="12px">
              {errors.regFiscal?.message}
            </Typography> */}

          <TextField
            select
            fullWidth
            label="Forma de pago"
            defaultValue=""
            inputProps={register('formaPago', {
              required: true
            })}
            error={errors.formaPago}
            helperText={errors.formaPago?.message}
          >
            {formaPagoList.map((option) => (
              <MenuItem key={option.Codigo} value={option.Codigo}>
                {option.Codigo} - {option.Valor}
              </MenuItem>
            ))}
          </TextField>
        </Stack>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 1 }}>
          <TextField
            select
            fullWidth
            label="Uso del CFDI"
            defaultValue=""
            inputProps={register('uso_CFDI', {
              required: true
            })}
            error={errors.uso_CFDI}
            helperText={errors.uso_CFDI?.message}
          >
            {usoCFDI_List.map((option) => (
              <MenuItem key={option.Codigo} value={option.Codigo}>
                {option.Codigo} - {option.Valor}
              </MenuItem>
            ))}
          </TextField>
        </Stack>

        <LoadingButton disabled={saved} loading={loading} fullWidth variant="contained" type="submit">
          Guardar direccion fiscal
        </LoadingButton>
      </Stack>
    </Card>
  );
}

export default FormDatosCliente;
